import Storefront from '@/gateway/Storefront';

export default class GatewayService {
  storeFront;

  static getStoreFront() {
    if (!this.storeFront) {
      const storefrontAccessToken = process.env.API_STOREFRONT_ACCESS_TOKEN;

      const shopifyDomain = window.localStorage.getItem('storefront-domain');
      this.storeFront = new Storefront({
        shopifyDomain,
        storefrontAccessToken
      });

      // const userAuth = ORW.utilities.getCookie('secure_customer_sig');

      //this.storeFront.userAuth = userAuth;
    }

    return this.storeFront;
  }
}
